import React from 'react';
import './detail-panel.css';

export default function DetailStatusLine({ items = [] }) {
  const visible = items.filter((item) => item && item.label);
  if (visible.length === 0) return null;

  return (
    <div className="detail-status-line">
      {visible.map((item) => (
        <span key={item.key || item.label} className="detail-status-item">
          {item.dot !== false ? (
            <span
              className={`detail-status-dot detail-status-dot--${item.tone || 'muted'}`}
              aria-hidden
            />
          ) : null}
          <span>{item.label}</span>
        </span>
      ))}
    </div>
  );
}
